import { message } from 'antd';
import type { MessageInstance } from 'antd/es/message/interface';

// 创建一个消息实例
let messageInstance: MessageInstance | null = null;

export const setMessageInstance = (instance: MessageInstance) => {
  messageInstance = instance;
};

export const showMessage = {
  success: (content: string) => {
    if (messageInstance) {
      messageInstance.success(content);
    } else {
      message.success(content);
    }
  },
  error: (content: string) => {
    if (messageInstance) {
      messageInstance.error(content);
    } else {
      message.error(content);
    }
  },
  warning: (content: string) => {
    if (messageInstance) {
      messageInstance.warning(content);
    } else {
      message.warning(content);
    }
  },
  info: (content: string) => {
    if (messageInstance) {
      messageInstance.info(content);
    } else {
      message.info(content);
    }
  },
}; 